document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.section-home-tabs');
    if(!section) return;

    const groupTabs = section.querySelectorAll('.section-home-tabs__tabs');
    const groupPanel = section.querySelectorAll('.section-home-tabs__panel');

    groupTabs.forEach(tab => initialiseScrolling(tab));
    groupPanel.forEach(panel => {
        const products = panel.querySelector('.section-home-tabs__products');
        if(!products) return;

        const arrowsWrapper = panel.querySelector('.section-home-tabs__arrows');
        const arrows = panel.querySelectorAll('.section-home-tabs__arrow');
        
        initialiseScrolling(products);

        const updateArrowsState = () => {
            if (arrows.length === 2) {
                arrows[0].disabled = isAtStart(products);
                arrows[1].disabled = isAtEnd(products);
            }
        };
        
        window.addEventListener('load', () => {
            toggleArrows(products, arrowsWrapper);
            updateArrowsState(); // Initial check
        });

        const resizeObserver = new ResizeObserver(() => { 
            toggleArrows(products, arrowsWrapper);
            updateArrowsState(); // Update if screen/container size changes
        });
        resizeObserver.observe(products);

        if(arrows.length === 2) {
            arrows[0].addEventListener('click', () => moveSlider(products, arrows, -1));
            arrows[1].addEventListener('click', () => moveSlider(products, arrows, +1));
            
            // Use the same function for the scroll event
            products.addEventListener('scroll', updateArrowsState);
        }
    });

    function toggleArrows(slider, arrows) {
        const isOverflowing = slider.scrollWidth > slider.clientWidth;

        if(arrows) {
            if(isOverflowing) arrows.classList.remove('hidden');
            else arrows.classList.add('hidden');
        } 
    }

    function isAtStart(element) {
        return element.scrollLeft <= 0;
    }

    function isAtEnd(element) {
        return Math.ceil(element.scrollLeft + element.clientWidth) >= (element.scrollWidth - 1);
    }

    function moveSlider(slider, arrows, modifier) {
        const card = slider.querySelector('.section-home-tabs__card');
        if(!card) return;

        const distance = card.clientWidth * modifier;
        slider.scrollBy({ left: distance, behavior: 'smooth' });
    }

    function initialiseScrolling(element) {
        let isDragging = false;
        let startScroll;
        let startX;

        element.addEventListener('mousedown', event => {
            isDragging = true;
            setIsDragging(element);
            
            startX = event.pageX - element.offsetLeft;
            startScroll = element.scrollLeft;            
        });

        element.addEventListener('mouseleave', () => {
            isDragging = false;
            setIsNotDragging(element);
        });

        element.addEventListener('mouseup', () => {
            isDragging = false;
            setIsNotDragging(element);
        });

        element.addEventListener('mousemove', event => {
            if(!isDragging) return;
            event.preventDefault();

            const currentX = event.pageX - element.offsetLeft;
            const scrollDistance = currentX - startX;

            element.scrollLeft = startScroll - scrollDistance;
        });
    };

    function setIsDragging(element) { element.classList.add('is-dragging') }
    function setIsNotDragging(element) { element.classList.remove('is-dragging') }
})